import Immutable from 'immutable'

import {
  createBandwidthPack,
  createCoupon,
  createOffer,
  createProduct,
} from '../../../records'

// ------------------------------------
// Constants
// ------------------------------------
export const LOAD_COUPONS = 'inf/product/LOAD_COUPONS'
export const LOAD_OFFERS = 'inf/product/LOAD_OFFERS'
export const LOAD_PRODUCTS = 'inf/product/LOAD_PRODUCTS'
export const RECEIVE_COUPONS = 'inf/product/RECEIVE_COUPONS'
export const RECEIVE_OFFERS = 'inf/product/RECEIVE_OFFERS'
export const RECEIVE_PRODUCTS = 'inf/product/RECEIVE_PRODUCTS'

export const constants = {
  LOAD_COUPONS,
  LOAD_OFFERS,
  LOAD_PRODUCTS,
  RECEIVE_COUPONS,
  RECEIVE_OFFERS,
  RECEIVE_PRODUCTS,
}

// ------------------------------------
// Actions
// ------------------------------------
export const loadCoupons = () => ({
  type: LOAD_COUPONS,
})
export const loadOffers = () => ({
  type: LOAD_OFFERS,
})
export const loadProducts = () => ({
  type: LOAD_PRODUCTS,
})
export const receiveCoupons = coupons => ({
  payload: { coupons },
  type: RECEIVE_COUPONS,
})
export const receiveOffers = offers => ({
  payload: { offers },
  type: RECEIVE_OFFERS,
})
export const receiveProducts = (bandwidthPacks, products) => ({
  payload: {
    bandwidthPacks,
    products,
  },
  type: RECEIVE_PRODUCTS,
})

export const actions = {
  loadCoupons,
  loadOffers,
  loadProducts,
  receiveCoupons,
  receiveOffers,
  receiveProducts,
}

// ------------------------------------
// Reducer
// ------------------------------------
export const initialState = Immutable.fromJS({
  bandwidthPacks: Immutable.Set(),
  coupons: Immutable.Set(),
  offers: Immutable.Set(),
  products: Immutable.Set(),
})

export default function reducer(state = initialState, { payload, type }) {
  function merge(extantItems, entries, constructor) {
    entries.forEach(entry => {
      const item = constructor(entry);
      if (!extantItems.find(search => search.id === item.id)) {
        extantItems = extantItems.add(item)
      }
    });
    return extantItems;
  }

  switch (type) {
    case RECEIVE_COUPONS: {
      const coupons = payload.coupons.reduce(
        (set, coupon) => set.add(createCoupon(coupon)),
        Immutable.Set(),
      )

      return state.set('coupons', coupons)
    }

    case RECEIVE_OFFERS: {
      return state.set('offers', merge(state.get('offers'), payload.offers, o => createOffer(o)))
    }

    case RECEIVE_PRODUCTS: {
      return state
        .set('bandwidthPacks', merge(state.get('bandwidthPacks'), payload.bandwidthPacks, p => createBandwidthPack(p)))
        .set('products', merge(state.get('products'), payload.products, p => createProduct(p)))
    }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/modules/product/index.js